export const LOCATION_CHANGED = "@@router/LOCATION_CHANGE";
export const NAVIGATION_REGISTERED = "NAVIGATION_REGISTERED";
export const NAVIGATED_TO = "NAVIGATED_TO";
export const NAVIGATED_BACK = "NAVIGATED_BACK";
export const NAVIGATION_CHANGED = "NAVIGATION_CHANGED";
